<template>
	<div class="login-view">
        <input v-model="pass" v-on:keyup.enter="checkPass" type="password" /> <button @click="checkPass"> login </button>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'WorldView',
    
    data() {
        return {
            pass: '',
        }
    },

    mounted() {
        this.$router.push({ path: 'catch', query: { test: 'test' } })
        this.$emit('wtf', this.getAuthenticated === 'true')
    },

    computed: {
        ...mapGetters([
            'getAuthenticated'
        ])
    },

    methods: {
        checkPass () {
            if (this.pass === '420') {
                this.$emit('authenticate')
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.world-view 
    border 1px solid black
    display flex
    flex-direction column

</style>



// WEBPACK FOOTER //
// src/views/LoginView.vue